import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    chineseSimplifiedChina: string;
    danish: string;
    dutch: string;
    englishIndia: string;
    englishUk: string;
    englishUs: string;
    frenchCanada: string;
    frenchFrance: string;
    german: string;
    hindi: string;
    italian: string;
    japanese: string;
    korean: string;
    norwegian: string;
    portugueseBrazil: string;
    portuguesePortugal: string;
    spanishArgentina: string;
    spanishLatinAmerica: string;
    spanishSpain: string;
    swedish: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Chinese (Simplified, China) */
            chineseSimplifiedChina: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.chineseSimplifiedChina?c=b6hwzss7x18x", defaultMessage: "Chinese (Simplified, China)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Danish */
            danish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.danish?c=iy4bcp2nbtem", defaultMessage: "Danish" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dutch */
            dutch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.dutch?c=klpcsy0sc2ul", defaultMessage: "Dutch" }));
                },
                enumerable: true,
                configurable: true
            },
            /** English as spoken in India */
            englishIndia: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.englishIndia?c=1g9gicmve6akr", defaultMessage: "English (India)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** English as spoken in the United Kingdom */
            englishUk: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.englishUk?c=xylpu7wrtkju", defaultMessage: "English (UK)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** English as spoken in the United States */
            englishUs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.englishUs?c=gvapgrqx4an0", defaultMessage: "English (US)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** French as spoken in Canada */
            frenchCanada: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.frenchCanada?c=3hamny1d3caxm", defaultMessage: "French (Canada)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** French as spoken in France */
            frenchFrance: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.frenchFrance?c=2lvuidl9frbdn", defaultMessage: "French (France)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** German */
            german: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.german?c=3vtfd4mh6r411", defaultMessage: "German" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Hindi */
            hindi: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.hindi?c=2muyua61rbvzb", defaultMessage: "Hindi" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Italian */
            italian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.italian?c=1todwvohn7vhg", defaultMessage: "Italian" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Japanese */
            japanese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.japanese?c=1wnfakaco47kj", defaultMessage: "Japanese" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Korean */
            korean: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.korean?c=2af9r49fofklk", defaultMessage: "Korean" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Norwegian */
            norwegian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.norwegian?c=114g0pvxhvtu9", defaultMessage: "Norwegian" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Portuguese as spoken in Brazil */
            portugueseBrazil: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.portugueseBrazil?c=23z5q53syghrq", defaultMessage: "Portuguese (Brazil)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Portuguese as spoken in Portugal */
            portuguesePortugal: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.portuguesePortugal?c=3uqe6sgmg20ze", defaultMessage: "Portuguese (Portugal)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Spanish as spoken in Argentina */
            spanishArgentina: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.spanishArgentina?c=3njzv8g6igqo5", defaultMessage: "Spanish (Argentina)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Spanish as spoken in Latin America */
            spanishLatinAmerica: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.spanishLatinAmerica?c=3b44ljyr53li5", defaultMessage: "Spanish (Latin America)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Spanish as spoken in Spain */
            spanishSpain: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.spanishSpain?c=22pzf3s4silf6", defaultMessage: "Spanish (Spain)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Swedish */
            swedish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "dubLanguages.swedish?c=3dagn8ourfez9", defaultMessage: "Swedish" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
